<template>
  <div class="glosario">
    <Titulo titulo="Glosario" />

    <b-row>
      <b-col cols="12" md="8">
        <div class="margin-lateral">
          <h4 class="color-secundary mb-4">Conozca los principales términos usados en este portal</h4>
          <div>
            <div v-for="(definicion, index) in glosario" :key="index" class="listas mb-3">
              <div v-if="!definicion.disabled">
                <b>{{definicion.nombre}}:</b>
                {{definicion.definicion}}
              </div>
            </div>
          </div>
        </div>
      </b-col>

     <!-- Panel Derecho --->
    <BannerRight/>
    </b-row>
  </div>
</template>
<script>
import Glosario from "@/data/Glosario.json";

export default {
  name: "Glosario",

  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    BannerRight: () => import("@/containers/layout/banner-right.vue"),
  },
  data: () => {
    return {
      glosario: Glosario
    };
  }
};
</script>